module.exports = __webpack_public_path__ + "img/trash-bin.e33c5af7.svg";